<template>
  <div class="lead-timeline" v-if="LeadData && Timetable">
    <span class="timeline-menu-list-ttl">Timeline</span>
    <menu-time-line/>
    <div class="lead-timeline-content">
      <div class="lead-timeline__item" v-for="items in Timetable"
           :class="{'lead-timeline__item--group': items.length > 1}">
        <comment-type v-if="items[0].action_type === 'comments'" :items="items"/>
        <updates-type v-if="items[0].action_type === 'updates'" :items="items"/>
      </div>
    </div>
  </div>
</template>

<script>
import CommentType from "./partials/CommentType";
import UpdatesType from "./partials/UpdatesType";
import MenuTimeLine from "./partials/MenuTimeLine";

export default {
  name: "TimeLineTab",
  components: {MenuTimeLine, UpdatesType, CommentType},
  data() {
    return {
      colors: [{
        type: 'FTD attempt',
        color: '#ed3838'
      }, {
        type: 'FTD',
        color: '#d9d230'
      }, {
        type: 'deposit attempt',
        color: '#ed3838'
      }, {
        type: 'deposit',
        color: '#5fbb3e'
      }]
    }
  },
  computed: {
    Timetable: {
      get() {
        return this.$store.state.timetable;
      },
      set(value) {
        this.$store.commit('setter', {timetable: value})
      }
    },
    LeadData() {
      let data = this.$store.state.leadData;

      if (data) {
          this.Timetable = this.groupBy(data.timetable)
      }

      return data;
    },
  },
}

// return entry.action_type + ',' + entry.user_name + ',' + entry["date&time"];


// data.forEach(function(element, index, array) {
//   var depositColor = [{
//     type: 'FTD attempt',
//     color: '#ed3838'
//   }, {
//     type: 'FTD',
//     color: '#d9d230'
//   }, {
//     type: 'deposit attempt',
//     color: '#ed3838'
//   }, {
//     type: 'deposit',
//     color: '#5fbb3e'
//   }];
//
//   $.each(depositColor, function(i, v) {
//     if (element[ld_update_type] == v.type) {
//       color = v.color;
//     }
//   })
//   var name = element[ld_user_name];
//   var date = element[ld_date_time];
//   var content;
//   var head;
//   var assign;
//   var autoUpdate;
//
//   if (element['userid'] > 0 && element['update_type'] == 'MT5 operation') {
//     assign = `MT5 operation by ${name}`
//   } else {
//     assign = `<span style='color:${color}'> ${element['update_type']}</span> by lead`
//   }
//
//
//
//   if (element[ld_action_type] == "comments" && (type == "comments" || type == "all")) {
//     content = element[ld_content];
//     list += '<div class="lead-timeline__item">';
//     list += '<div class="lead-timeline-info"><div class="timeline-avtor"><div class="lead-timeline-action timeline-comment">Commented </div><div class="lead-timeline-employee">by' + ' ' + name + ':</div></div><div class="timline-date">' + date + '</div></div>';
//     list += '<div class="timeline__item_text">' + content + '</div>';
//     list += "</div>";
//   } else if (element[ld_action_type] == "updates" && (type == "updates" || type == "all")) {
//
//
//     /* 			if( (element[ld_action_type] == "updates" && element['userid']) == 0 || name == null ){
//             name = 'Updated automatically'
//           }
//           console.log(name,1232131132, element); */
//
//     if (element[ld_update_type] == "home") {
//       var oldSiteUri = getHomeImg(element[ld_old_value]);
//       var oldSiteName = element[ld_old_value].toLowerCase();
//       var newSiteUri = getHomeImg(element[ld_new_value]);
//       var newSiteName = element[ld_new_value].toLowerCase();
//       head = '<div class="lead-timeline-info"><div class="timeline-avtor"><div class="lead-timeline-action timeline-home">Home updated by</div><div class="lead-timeline-employee">' + name + '</div></div><div class="timline-date">' + date + '</div></div>';
//       content = '<div class="timeline__item_text"><span><img src="' + oldSiteUri + '"></span><span>' + oldSiteName + '</span><span>-></span><span><img src="' + newSiteUri + '"></span><span>' + newSiteName + '</span></div>';
//     } else if (element[ld_update_type] == "leadstatus") {
//       var saleStatusStyleOld = getSaleStatusStyle(element[ld_old_value]);
//       var saleOldName = element[ld_old_value];
//       var statusOld = '<div class="lead-info-status td--salestatus"> <div class="ui-ddbox ui-ddbox-select ' + saleStatusStyleOld + '" data-table="" data-id="" data-leadid="" data-task="salestatus"><button class="ui-ddbtn"><span class="ui-ddbtnvalue">' + saleOldName + '</span> <i class="fa fa-caret-down" aria-hidden="true"></i></button> <div class="ui-ddbody"> <div class="ui-ddsection ui-salestatusList"> <div> </div> </div> </div> </div></div>';
//       var saleStatusStyleNew = getSaleStatusStyle(element[ld_new_value]);
//       var saleNewName = element[ld_new_value];
//       var statusNew = '<div class="lead-info-status td--salestatus"> <div class="ui-ddbox ui-ddbox-select ' + saleStatusStyleNew + '" data-table="" data-id="" data-leadid="" data-task="salestatus"><button class="ui-ddbtn"><span class="ui-ddbtnvalue">' + saleNewName + '</span> <i class="fa fa-caret-down" aria-hidden="true"></i></button> <div class="ui-ddbody"> <div class="ui-ddsection ui-salestatusList"> <div> </div> </div> </div> </div></div>';
//       head = '<div class="lead-timeline-info"><div class="timeline-avtor"><div class="lead-timeline-action timeline-status">Status updated by</div><div class="lead-timeline-employee">' + name + '</div></div><div class="timline-date">' + date + '</div></div>';
//       content = '<div class="timeline__item_text"><div class="status-updated-wrapper">' + statusOld + '<div class="status-updated__item status-updated-arrow">-></div>' + statusNew + '</div></div>';
//     } else if (element[ld_update_type] == "create") {
//       head = '<div class="lead-timeline-info"> <div class="timeline-avtor"> <div class="lead-timeline-action timeline-lead-created">Lead was created</div> </div> <div class="timline-date">' + date + '</div></div>';
//       content = "";
//     } else {
//       var assignNameOld = element[ld_old_value];
//       var assignNameNew = element[ld_new_value];
//       head = '<div class="lead-timeline-info"><div class="timeline-avtor"><div class="lead-timeline-action timeline-assign">' + capitalizeFirstLetter(element[ld_update_type]) + ' updated by</div><div class="lead-timeline-employee">' + name + '</div></div><div class="timline-date">' + date + '</div></div>';
//       content = '<div class="timeline__item_text"><span>' + assignNameOld + '</span><span>-></span><span>' + assignNameNew + '</span></div>';
//     }
//     list += "<div class='lead-timeline__item'>";
//     list += head;
//     list += content;
//     list += "</div>";
//   } else if (element[ld_action_type] == "calls" && (type == "calls" || type == "all")) {
//     list += "<div class='lead-timeline__item'>";
//     list += '<div class="lead-timeline-info"><div class="timeline-avtor"><div class="lead-timeline-action timeline-called">Called </div><div class="lead-timeline-employee">by ' + name + '</div></div><div class="timline-date">' + date + '</div></div>';
//     list += "</div>";
//   } else if (element[ld_action_type] == "balance" && (type == "balance" || type == "all")) {
//     content = assign + '<br>' + element[ld_content];
//     list += "<div class='lead-timeline__item'>";
//     list += '<div class="lead-timeline-info"><div class="timeline-avtor"> <div class="lead-timeline-action"> ' + content + '</div> </div><div class="timline-date">' + date + '</div></div>';
//     list += "</div>";
//   }
// })


</script>

<style scoped>

</style>
